import { render, staticRenderFns } from "./ModalProductInformation.vue?vue&type=template&id=3276efd0&scoped=true"
import script from "./ModalProductInformation.vue?vue&type=script&lang=js"
export * from "./ModalProductInformation.vue?vue&type=script&lang=js"
import style0 from "./ModalProductInformation.vue?vue&type=style&index=0&id=3276efd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3276efd0",
  null
  
)

export default component.exports